var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebcam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0018 21.0812C19.7037 21.0812 23.5153 17.2696 23.5153 12.5677C23.5153 7.86583 19.7037 4.0542 15.0018 4.0542C10.2999 4.0542 6.48828 7.86583 6.48828 12.5677C6.48828 17.2696 10.2999 21.0812 15.0018 21.0812ZM15.0018 21.0812V25.9461M8.92071 25.9461H15.0018M15.0018 25.9461H21.0829M18.6504 12.5677C18.6504 14.5828 17.0169 16.2164 15.0018 16.2164C12.9867 16.2164 11.3531 14.5828 11.3531 12.5677C11.3531 10.5526 12.9867 8.91906 15.0018 8.91906C17.0169 8.91906 18.6504 10.5526 18.6504 12.5677Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebcam);
export default __webpack_public_path__ + "static/media/webcam.b3f7251b64249a21a74ee2d45fb2515a.svg";
export { ForwardRef as ReactComponent };